<div class="container">
  <!-- <tr>
    <td *ngFor="let stato of staticommessa" class="tile">
  -->    <mat-card *ngFor="let stato of staticommessa" class="tile">
            <mat-card-header class="header">
              <div class="title">
                <mat-card-title [style.color]="getStatusColor(stato.Nome)">{{stato.Nome}}</mat-card-title>
              </div>
            </mat-card-header>
            <mat-card-content class="content"> <!-- style="display: flex; justify-content: center;">-->
              <div class="value">
                <span>{{valoristato[stato.Codice].value}}</span>
              </div>
            </mat-card-content>
            <mat-card-actions class="actions">
              <button mat-raised-button color="primary" (click)=dettaglio(stato)>Visualizza lista</button>
            </mat-card-actions>
          </mat-card>
<!--        </td>
    </tr>-->
</div>
